export interface IEmailAddressField {
    emailAddressFieldId: number,
    description: string
}